import React, { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import dayjs from "dayjs"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"

import { ROUTES } from "../../routes"
import { useLanguage } from "@languages/index"
import { CampaignDto } from "api/repositories/campaign/campaign.types"
import Button from "../../components/button"

const CampaignComplete = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }

  const navigate = useNavigate()
  const location: { state: { campaign: CampaignDto; isUpdate?: boolean } } = useLocation()

  useEffect(() => {
    props.resetCampaignState()
  }, [])

  const renderPageTitle = () => {
    return (
      <>
        <div
          className="page-title flex justify-center"
          style={{
            fontSize: 22,
            letterSpacing: "-5%",
            fontWeight: 700,
          }}
        >
          {languageTexts.complete_title(location.state.isUpdate)}
        </div>
      </>
    )
  }

  const renderCampaignInfo = () => {
    return (
      <div className="flex flex-col p-6 gap-3 border border-gray-200 rounded my-[64px]">
        <div className="flex flex-row justify-between">
          <div>
            <span className="text-sm tracking-tighter font-bold">{languageTexts.complete_info_1}</span>
          </div>
          <div>
            <span className="text-sm tracking-tighter">{location.state.campaign.recruitStartsAt}</span>
            <span className="text-sm tracking-tighter">{` ~ `}</span>
            <span className="text-sm tracking-tighter">{location.state.campaign.recruitEndsAt}</span>
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <div>
            <span className="text-sm tracking-tighter font-bold">{languageTexts.complete_info_2}</span>
          </div>
          <div>
            <span className="text-sm tracking-tighter">{location.state.campaign.selectionStartsAt}</span>
            <span className="text-sm tracking-tighter">{` ~ `}</span>
            <span className="text-sm tracking-tighter">{location.state.campaign.selectionEndsAt}</span>
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <div>
            <span className="text-sm tracking-tighter font-bold">{languageTexts.complete_info_3}</span>
          </div>
          <div>
            <span className="text-sm tracking-tighter">{location.state.campaign.productDeployAt}</span>
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <div>
            <span className="text-sm tracking-tighter font-bold">
              {location.state.campaign.isSingleDayPosting 
                ? languageTexts.complete_info_4_1
                : languageTexts.complete_info_4}
            </span>
          </div>
          {location.state.campaign?.isSingleDayPosting ? (
            <div>
              <span className="text-sm tracking-tighter">
                {dayjs(location.state.campaign.postingEndsAt).subtract(2, 'day').format('YYYY-MM-DD')}
              </span>
            </div>
          ) : (
            <div>
              <span className="text-sm tracking-tighter">{location.state.campaign.postingStartsAt}</span>
              <span className="text-sm tracking-tighter">{` ~ `}</span>
              <span className="text-sm tracking-tighter">{location.state.campaign.postingEndsAt}</span>
            </div>
          )}
        </div>
      </div>
    )
  }

  const renderConfirmButton = () => {
    return (
      <div className="flex flex-col">
        <Button
          bordered
          text={languageTexts.confirm}
          textColor={"WHITE"}
          buttonColor={"#121212"}
          borderColor={"#121212"}
          onClick={() => {
            navigate(ROUTES.CAMPAIGN_INDEX.PATH, { replace: true })
          }}
        />
      </div>
    )
  }

  return (
    <>
      <div className="px-5 mx-auto h-[100dvh] flex flex-col justify-center" style={{ maxWidth: "450px" }}>
        {renderPageTitle()}
        {renderCampaignInfo()}
        {renderConfirmButton()}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignComplete)
